export function noAuthHeader() {
    return {
        'Content-Type':'application/json',
        'keyAuthorization': "4t4hBRB45634u5ii5i6bHT45575NEhrh576iEGrh",
    };
}
export function authHeader() {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user['AuthToken'].length > 0) {
        return { 'tAuthorization': user['AuthToken'],
            'Content-Type':'application/json',
        };
    } else {
        return {};
    }
}


export function authHeaderFile() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));

    if (user['AuthToken'].length > 0) {
        return {'tAuthorization': user['AuthToken'],
        };
    } else {
        return {};
    }
}